/**
 * Client-only device fingerprint headers via lazy PersistentLoginUtil import.
 * Gated by persistent-login killswitches. Returns {} on SSR or any failure.
 */
async function getDeviceFingerPrintHeaders() {
  if (!import.meta.client) {
    return {};
  }

  try {
    const { useKillswitchesStore } = await import('../stores/useKillswitchesStore');
    const killswitchesStore = useKillswitchesStore();
    if (!killswitchesStore.persistentLoginEnabled || !killswitchesStore.persistentLoginForLoyaltyHubEnabled) {
      return {};
    }

    const { PersistentLoginUtil } = await import('@nuxt-common/util/app/utils/persistentLogin');
    return PersistentLoginUtil.getDeviceFingerPrintHeaders() || {};
  } catch {
    return {};
  }
}

/** Headers for GET /xapi/loyalty/v1/unified/summary. */
export async function getSummaryHeaders() {
  return {
    'X-Requested-With': 'XMLHttpRequest',
    ...(await getDeviceFingerPrintHeaders()),
  };
}

/**
 * Headers for loyalty API calls (POST/DELETE/etc.).
 *
 * @param {Object} cookies Cookie util with `.get(name)`
 * @param {string=} brand `'bcom'` | `'mcom'`
 * @returns {Promise<Object>}
 */
export default async function getHeader(cookies, brand) {
  const get = (name) => (cookies && typeof cookies.get === 'function' ? cookies.get(name) : undefined);

  const bcomGuid = get('bloomingdales_online_guid');
  const bcomUid = get('bloomingdales_online_uid');

  const resolvedBrand = brand || (bcomGuid || bcomUid ? 'bcom' : 'mcom');

  const guidKey = resolvedBrand === 'bcom' ? 'bloomingdales_online_guid' : 'macys_online_guid';
  const uidKey = resolvedBrand === 'bcom' ? 'bloomingdales_online_uid' : 'macys_online_uid';

  return {
    'Content-Type': 'application/json',
    'X-Macys-Userguid': get(guidKey),
    'X-Macys-SignedIn': get('SignedIn'),
    'X-Macys-UID': get(uidKey),
    'x-requested-with': 'XMLHttpRequest',
    ...(await getDeviceFingerPrintHeaders()),
  };
}
